/* oxlint-disable no-underscore-dangle */
/**
 * Config resolved at RUNTIME (build-once → promote dev→staging→prod strategy).
 *
 * - Web/PWA: the container injects `window.__APP_CONFIG__` via `/config.js` (the
 *   nginx entrypoint generates it from environment variables at startup). One
 *   image serves all environments; only the container env changes.
 * - Tauri (desktop/mobile): there is no `/config.js`; falls back to baked-in
 *   `import.meta.env.VITE_*` values (build-time) → behavior unchanged.
 * - Local dev: same (import.meta.env from apps/web/.env) or fallback to localhost.
 */
interface AppRuntimeConfig {
  SERVER_URL?: string;
  POWERSYNC_URL?: string;
}

const runtime: AppRuntimeConfig =
  (globalThis as typeof globalThis & { __APP_CONFIG__?: AppRuntimeConfig }).__APP_CONFIG__ ?? {};

/**
 * First ACTUALLY present value. Plain `??` is not enough: the entrypoint
 * writes `"CLAVE": ""` for every env the container does not define, and an empty
 * string is not nullish → it would beat the default and leave, for example, a
 * blank base URL. Here "unconfigured" and "empty" mean the same thing.
 */
function firstConfigured(...values: (string | undefined)[]): string | undefined {
  return values.find((v) => v !== undefined && v.trim() !== "")?.trim();
}

/** Backend base (auth/api/server). */
export const SERVER_URL: string =
  firstConfigured(
    runtime.SERVER_URL,
    import.meta.env.VITE_SERVER_URL,
    import.meta.env.VITE_API_URL,
  ) ?? "http://localhost:3333";

/** PowerSync service endpoint. */
export const POWERSYNC_URL: string =
  firstConfigured(runtime.POWERSYNC_URL, import.meta.env.VITE_POWERSYNC_URL) ??
  "http://localhost:8085";
